import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';
import { IIssueReportListItem } from '@types';

// 특정 이미지에 대한 오류 리포트 리스트 불러오기
async function getImageIssueReportList(imageId?: number): Promise<AxiosResponse<FetchResult<IIssueReportListItem[]>>> {
  const response = await instance.get(`/images/${imageId}/issue-reports`);
  console.log('response');
  return response;
}

const useFetchImageIssueReportList = (imageId?: number) => {
  const { data: originalData, isLoading } = useQuery({
    queryKey: ['get', `/images/${imageId}/issue-reports`],
    queryFn: () => getImageIssueReportList(imageId),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(imageId),
    // 하단 네 개의 프로퍼티는 캐시 데이터가 남아있지 않도록 처리하기 위한 프로퍼티임
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    initialData: undefined
  });

  const data = originalData?.data.data;

  return { data, isLoading };
};

export default useFetchImageIssueReportList;
